import { SIP_CLIENT_ACTIONS, REDUCERS } from '../../constants.js';

const initialSipClientActions = {
	reducer_type: REDUCERS.SIP_CLIENT_ACTIONS,
	actionType: SIP_CLIENT_ACTIONS.NONE,
	stream: 0
};

const sipClientActions = (state = initialSipClientActions, action) => {
	state = initialSipClientActions;
	switch (action.type) {
		case SIP_CLIENT_ACTIONS.HANGUP:
			return { actionType: SIP_CLIENT_ACTIONS.HANGUP };
		case SIP_CLIENT_ACTIONS.STREAM:
			return {
				stream: action.data
			};
		default:
			return state;
	}
};

export default sipClientActions;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_sip_client_actions.js